(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ================================================= STICKY HEADER ================================================= */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;
      this.headerBounds = this.header.getBoundingClientRect();
      window.addEventListener('scroll', this.onScroll.bind(this));
    }

    onScroll() {
      if (window.scrollY > this.headerBounds.bottom) {
        this.header.classList.add('scrolled');
      } else {
        this.header.classList.remove('scrolled');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ================================================= DESKTOP MEGA MENU — JS HOVER (NO CSS HOVER) ================================================= */
  document.addEventListener('DOMContentLoaded', () => {
    const megaItems = document.querySelectorAll('.menu-item.has-mega');

    megaItems.forEach(item => {
      const megaMenu = item.querySelector('.mega-menu');
      if (!megaMenu) return;

      let closeTimer;

      // OPEN
      item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);

        // Close all other mega items
        megaItems.forEach(i => {
          if (i !== item) i.classList.remove('mega-open');
        });

        item.classList.add('mega-open');
      });

      // CLOSE
      item.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          item.classList.remove('mega-open');
        }, 150); // prevents flicker
      });
    });

    /* ================================================= MOBILE SUBMENU — ARROW ONLY ================================================= */
    document.querySelectorAll('.submenu-toggle').forEach(toggle => {
      toggle.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        const parentLi = toggle.closest('li');
        if (!parentLi) return;

        parentLi.classList.toggle('open');
      });
    });

    /* ================================================= MOBILE — CLOSE DRAWER ON REAL LINK CLICK ================================================= */
    document.querySelectorAll('.drawer-nav a').forEach(link => {
      link.addEventListener('click', () => {
        closeMobileMenu();
      });
    });
  });

  
document.addEventListener('DOMContentLoaded', () => {

  /* ================= DESKTOP SEARCH POPUP ================= */
  const popup = document.getElementById('desktopSearchPopup');
  const triggers = document.querySelectorAll('.search-trigger');
  const closeBtn = popup.querySelector('.close-search');

  function openPopup() {
    if (!popup || !popup.hasAttribute('hidden')) return;
    popup.removeAttribute('hidden');
    popup.querySelector('input').focus();
  }

  function closePopup() {
    popup.setAttribute('hidden', true);
  }

  triggers.forEach(t => {
    t.addEventListener('click', e => {
      e.preventDefault();
      openPopup();
    });
  });

  closeBtn.addEventListener('click', closePopup);

  document.addEventListener('click', e => {
    if (popup.hasAttribute('hidden')) return;
    if (!popup.contains(e.target) && !e.target.closest('.search-trigger')) {
      closePopup();
    }
  });

});

  } catch(e) { console.error(e); }
})();
})();
